import { useEffect } from "react";
import Banner from "../components/PremiumService/Banner";
import Package from "../components/PremiumService/Package";
import Become from "../components/PremiumService/Become";
import Overview from "../components/PremiumService/Overview";

function PremiumService() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-[#EFEFEF] relative overflow-hidden">
            <Banner />
            <Package />
            <Become />
            <Overview />
            
        </div>
    );
}

export default PremiumService;
